









































































































































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ajax from '@/lib/ajax';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import PayslipDto from '@/models/Payroll/PayslipDto';

@Component({
    name: 'WorkerPayslips',
})
export default class extends GiganautVue {
    loading = false;
    payslips: PayslipDto[] | null = null;
    selected: PayslipDto | null = null;


    headers = [
        { text: 'Period', value: 'externalPayrollSystemPeriodId', sortable: false },
        { text: 'Payment date', value: 'paymentDate', sortable: false },
        { text: 'Gross', value: 'grossPay', align: 'end', sortable: false },
        { text: 'Net', value: 'netPay', align: 'end', sortable: false },
    ];

    get workerId(): string {
        return WorkerDetailsModule.currentWorker ? WorkerDetailsModule.currentWorker.id : '';
    }

    mounted() {
        this.loadPayslips();
    }

    @Watch('workerId')
    onWorkerChanged(val: string) {
        if (val) {
            this.loadPayslips();
        }
    }

    async loadPayslips() {
        if (!this.workerId) return;
        this.loading = true;
        try {
            const response = await ajax.get(`/api/v1/agency/workers/${this.workerId}/payslips`);
            this.payslips = response.data || [];
            // Keep the current selection across reloads when possible;
            // otherwise default to the newest payslip.
            const previousId = this.selected ? this.selected.id : '';
            this.selected = (this.payslips || []).find(p => p.id === previousId)
                || ((this.payslips && this.payslips.length > 0) ? this.payslips[0] : null);
        } catch (e: any) {
            this.payslips = [];
            this.selected = null;
        } finally {
            this.loading = false;
        }
    }

    formatShortDate(s: string): string {
        const d = new Date(s);
        return isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
    }

    formatDateTime(s: string): string {
        const d = new Date(s);
        return isNaN(d.getTime()) ? '—' : d.toLocaleString();
    }

    formatPence(p: number): string {
        if (!p) return '£0.00';
        return '£' + (p / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}
